<div class="header">

  <h1 class="header-title">{{ 'ORDERS.ORDERS' | translate }}</h1>
  <app-order-filter></app-order-filter>

</div>

<div class="content-filter">
  <mat-form-field appearance="outline">
    <mat-label [translate]="'ORDERS.CONTENT_FILTER'">Order content</mat-label>
    <mat-select (openedChange)="onContentPanelToggled($event)" (selectionChange)="onContentFilterChange($event.value)"
      [value]="contentFilterSelection" multiple panelClass="content-filter-panel">
      <mat-form-field appearance="outline" class="content-filter-search">
        <input #contentNameSearchInput (keydown)="onSearchKeydown($event)" (ngModelChange)="onContentNameSearch($event)"
          [ngModel]="contentNameSearch" [ngModelOptions]="{standalone: true}"
          [placeholder]="'COMMON.SEARCH' | translate" autocomplete="off" matInput>
      </mat-form-field>
      <mat-option *ngFor="let name of filteredContentNames" [value]="name">{{ name }}</mat-option>
    </mat-select>
    <button *ngIf="contentFilterSelection.length > 0" (click)="clearContentFilter($event)" mat-icon-button matSuffix>
      <mat-icon>close</mat-icon>
    </button>
  </mat-form-field>
</div>

<div class="orders">

  <div class="card-container">

    <h3 class="details-count">
      <ng-container *ngIf="contentFilterSelection.length > 0">{{ (filteredOrders$ | async)?.length }} / </ng-container>
      {{ ordersCount$ | async }} {{ 'ORDERS.ORDERS' | translate | lowercase }}
    </h3>
    <ul class="order-list">
      <ng-container *ngFor="let order of filteredOrders$ | async; let i = index">
        <app-order-list-item
          [currentOrder]="currentOrder$ | async"
          [order]="order"
          [selected]="(currentOrder$ | async) ? order.id === (currentOrder$ | async).id : i === 0"
        ></app-order-list-item>
      </ng-container>
    </ul>

  </div>
  <mat-progress-bar *ngIf="isLoading; else noloader" color="accent" mode="indeterminate"></mat-progress-bar>
  <ng-template #noloader>
    <div *ngIf="(ordersCount$ | async) > 0; else noOrders" style="width: 100%;">
      <app-order-list-details></app-order-list-details>
    </div>
    <ng-template #noOrders>
      <div style="padding: 24px 40px;">
        {{"ORDERS.ORDERS_NOT_FOUND" | translate}}
      </div>
    </ng-template>
  </ng-template>

</div>
